import React from "react";
import { View, StyleSheet } from "react-native";
import { TextInput, Scaffold } from "components";
import { Formik } from "formik";
import * as yup from "yup";
import { useNavigation } from "@react-navigation/native";
import useNavigationParam from "lib/use-navigation-param";
import useCustomBack from "lib/use-custom-back";
import SubmitErrorHandler from "lib/on-submit-error-handler";
import { DataStore } from "@aws-amplify/datastore";
import { Manufacturer } from "models";
import { updateManufacturer } from "./utils";
import fixNull from "lib/fix-null";

export default function ManufacturerDescription() {
  const navigation = useNavigation();
  const id = useNavigationParam<string>("id");
  const descriptionParam = useNavigationParam<string>("description") || "";
  const customBack = useCustomBack();

  return (
    <Scaffold>
      <Formik
        initialValues={{ description: fixNull(descriptionParam) }}
        validationSchema={validatorSchema}
        onSubmit={async (values) => {
          const manufacturer = await DataStore.query(Manufacturer, id);
          updateManufacturer(manufacturer, values, navigation);
        }}
      >
        {({ submitForm }) => {
          customBack(submitForm);
          return (
            <>
              <TextInput
                name="description"
                placeholder="Enter a description for the manufacturer"
              />
              <SubmitErrorHandler />
            </>
          );
        }}
      </Formik>
    </Scaffold>
  );
}

const validatorSchema = yup.object().shape({
  description: yup.string().required("Field is required"),
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 40,
    paddingHorizontal: 40,
    backgroundColor: "white",
  },
});
